import { IconSchool } from '@tabler/icons-react';
import s from './cta-card.module.scss';

export const CtaCard = ({ onBook }) => (
  <div className={s.ctaCard}>
    <div className={s.ctaHeader}>
      <div className={s.ctaIcon}>
        <IconSchool size={20} color="#F87728" />
      </div>
      <div className={s.ctaText}>
        <p className={s.ctaTitle}>Хотите заниматься чаще?</p>
        <p className={s.ctaSubtitle}>Запишитесь на дополнительное занятие</p>
      </div>
    </div>
    <button className={s.ctaButton} onClick={onBook} type="button">
      Записаться на занятие
    </button>
  </div>
);
